export default "__VITE_ASSET__De$ObqrT__"